import {FetchException} from "./FetchException";

export const fetchWithFetchException = async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    try {
        return await fetch(input, init);
    } catch (error: any) {
        throw new FetchException(input, error)
    }
}
